import { createContext } from 'react';

interface SocialShareModalContextProps {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  downloadImage: () => void;
  loadShareData: () => Promise<void>;
  setCurrentTemplate: React.Dispatch<React.SetStateAction<string | undefined>>;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;

  shareUrl: string;
  sharedImages: {
    [key: string]: string;
  };
  sharedImageFile?: File
  isLoading: boolean;

  error?: unknown | null;
}

export const SocialShareModalContext = createContext<SocialShareModalContextProps
| undefined>(undefined);
